import React from 'react';
import { images } from '../../../constants';
import { StyleSheet, css } from 'aphrodite';

const FloorMap = () => {
  return (
    <div className={css(styles.floorWrapper)}>
      <h1 className={css(styles.title)}>Floor Map Coming Soon.</h1>
      <img src={images.gallery5} alt="floor" className={css(styles.floorImage)} />
    </div>
  );
};

const styles = StyleSheet.create({
  floorWrapper: {
    width: '90%',
    maxWidth: '500px',
    margin: '2rem auto',
    textAlign: 'center',
  },

  title: {
    fontFamily: 'var(--font-alt)',
    fontSize: '1rem',
    color: '#c8b289',
  },

  floorImage: {
    width: '100%',
    maxWidth: '100%',
    height: 'auto',
    marginTop: '2rem',
    borderRadius: '10px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
  },
});

export default FloorMap;